import { Box, Container, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import { useEffect, useRef, useState } from "react";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { headCellsTitulosPagar } from "../PreFiltrosListagem/dataGridConfig";
import DialogListarTodas from "../../../../../components/DialogListarTodas";
import BtnExportar from "../../../../../components/BtnExportar";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import { TOpcoesVisualizacao } from "../../..";
import BackdropTable from "../../../../../components/BackdropTable";
import TableTitulosPagar from "./TableTitulosPagar";
import PreFiltros from "../PreFiltrosListagem";
import DialogRegistrarPagamento from "../DialogRegistrarPagamento";
import DialogIncluirPagamento from "../DialogIncluirPagamento";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";
import moment from "moment";
import { useModalDetalheTituloPagar } from "../ModalDetalheTituloContext";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { TableDataGridV2 } from "../../../../../components/TableDataGridV2";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function Listagem() {

    const { openModal } = useModalDetalheTituloPagar();
    const containerRef = useRef<HTMLDivElement>(null);

    const { setParamsUrl, searchParams, setMultipleParamsUrl } = useSetParamsURL()

    const [openFullScreen, setOpenFullScreen] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState<TOpcoesVisualizacao | null>();
    const [openRegistrarDialog, setOpenRegistrarDialog] = useState<boolean>(false);
    const [openIncluirDialog, setOpenIncluirDialog] = useState<boolean>(false);
    const [preFiltro, setPreFiltro] = useState<boolean>(true)

    //funções manipuladoras
    const handleChangePreFilters = (value: TPreFilters) => {
        const filteredValues: Record<string, any> = {};

        Object.entries(value).forEach(([key, value]) => {
            if (value === null || value === "" || (Array.isArray(value) && value.length === 0) || value === "null" || value === 'undefined' || value === undefined) {
                filteredValues[key] = ""
                return
            }
            if (moment.isMoment(value)) {
                filteredValues[key] = value.format("YYYY-MM-DD");
            } else {
                filteredValues[key] = value;
            }
        });
        setMultipleParamsUrl(filteredValues);
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const handleSelectFilters = (arg: TPreFilters) => {
        handleChangePreFilters(arg)
        setOpenBackdrop(null)
    }

    const handleClosePreFilter = () => {
        setPreFiltro(false)
        setOpenBackdrop(null)
    }
    //

    useEffect(() => {
        if (searchParams.size > 0) {
            setPreFiltro(false)
        }
    }, [searchParams])

    //valores importantes
    const listaAcoesRapidas: TItemAcaoRapida[] = [
        {
            label: "Cadastrar título a pagar",
            icon: <MonetizationOnIcon color="primary" />,
            action: () => setOpenIncluirDialog(true),
            havePermission: usePermission("financeiro.incluir-titulo-pagar")
        },
        {
            label: "Registrar pagamento",
            icon: <DownloadDoneIcon color="primary" />,
            action: () => setOpenRegistrarDialog(true),
            havePermission: usePermission("financeiro.registrar-pagamento")
        },
        {
            label: "Resumo por público",
            icon: <PersonPinOutlinedIcon color="primary" />,
            action: () => setOpenBackdrop("Por público"),
            havePermission: true
        },
        {
            label: "Resumo por departamento",
            icon: <ListAltOutlinedIcon color="primary" />,
            action: () => setOpenBackdrop("Por departamento"),
            havePermission: true
        },
    ]

    const RenderListagem = () => (
        <>
            {
                preFiltro &&
                <Box
                    minHeight={300}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <PreFiltros
                        filtros={searchParams}
                        isListarTodas
                        onSubmitFilters={(values) => {
                            handleChangePreFilters(values)
                            handleClosePreFilter()
                        }}
                    />
                </Box>
            }

            {
                !preFiltro &&
                <>
                    <BtnExportar boxProps={{ p: 2 }} />
                    <TableDataGridV2
                        urlParams
                        columns={headCellsTitulosPagar}
                        url="/financeiro/contas-pagar/pesquisar-titulos-pagar"
                        queryKey="listar-todos-titulos-pagar"
                        pagination="server"
                        onRowDoubleClick={(id) => {
                            setParamsUrl(id.toString(), "detalhe-titulo-pagar")
                            openModal(id.toString())
                        }}
                    />
                </>
            }
        </>
    )
    // 
    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.listar-titulo-pagar">

                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5">Títulos a pagar</Typography>

                    <Box sx={{ my: 2 }} />

                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}} ref={containerRef}>
                            <Box component={Paper}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2}>
                                    <Typography variant="h6">Lista de títulos</Typography>

                                    {
                                        !preFiltro &&
                                        <Stack alignItems="flex-end" justifyContent="center" direction="row" gap={2}>
                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setPreFiltro(true)}>
                                                <TuneOutlinedIcon />
                                            </IconButton>

                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setOpenFullScreen(true)}>
                                                <FullscreenIcon />
                                            </IconButton>
                                        </Stack>
                                    }
                                </Box>

                                <RenderListagem />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
                {
                    openBackdrop &&
                    <BackdropTable
                        open={Boolean(openBackdrop)}
                        handleClose={() => setOpenBackdrop(null)}
                        table={<TableTitulosPagar preVisualizacao={openBackdrop} handleChangePreFilters={handleSelectFilters} />}
                    />
                }
                {
                    openFullScreen &&
                    <DialogListarTodas
                        open={openFullScreen}
                        handleClose={() => setOpenFullScreen(false)}
                        title="Lista de títulos a pagar"
                    >
                        <RenderListagem />
                    </DialogListarTodas>
                }
                {
                    openRegistrarDialog &&
                    <DialogRegistrarPagamento
                        open={openRegistrarDialog}
                        handleClose={() => {
                            setOpenRegistrarDialog(false)
                        }}
                    />
                }
                {
                    openIncluirDialog &&
                    <DialogIncluirPagamento
                        open={openIncluirDialog}
                        handleClose={() => {
                            setOpenIncluirDialog(false)
                        }}
                    />
                }
            </PermissionGuard>
        </>
    )
}

export type TPreFilters = {
    [key: string]: any
}